export default class Language {
    public name : string = "";
    public code : string = "";
    public selected : boolean = true;
}